/**
 * 일반사항·회계정책·추정 등의 목차(1~3번)에 있는 표는 셀 단위 태깅 대상이 아니다.
 *
 * 백엔드가 표/시트마다 `taggingTarget` 으로 내려주고, 화면은 그 표를 목록에서 빼는
 * 대신 "블록태깅"으로 보여준다 — 빼버리면 "1. 일반사항의 종속기업 현황표가 왜 없지?" 가 된다.
 * 오토태깅 진행상황·XBRL 태그 불러오기 두 모달이 같은 문구를 쓴다. 분석 안 된 시트
 * 안내("블록태깅 대상 주석이에요")와 어휘를 맞춘다.
 */
export const TAGGING_EXCLUDED_LABEL = "블록태깅";

export const TAGGING_EXCLUDED_TOOLTIP =
  "일반사항·회계정책·추정 등의 목차는 블록태깅 대상이라 제외됩니다.";

/** 모달 머리말에 붙는 한 줄 — 제외 표가 하나라도 있을 때만 그린다. */
export const taggingExcludedNotice = (count: number) =>
  `일반사항·회계정책·추정 등의 목차는 블록태깅 대상이라 제외됩니다. (표 ${count}개)`;
